import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class CouponSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { coupons: [] };
        this.getCoupons = this.getCoupons.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getCoupons();
    }

    componentWillUnmount() {
    }

    getCoupons() {
        this.http.get('/api/Coupon/GetCoupons', {orderBy: "ClaimCode"}).then(data=>{
            this.setState({ coupons: data });
            if(data.length > 0 && this.props.value === 0){
                this.props.onChange(data[0].key);
            }
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.coupons.map((coupon) =>
            <option key={coupon.couponID} value={coupon.couponID}>{coupon.claimCode}</option>
        );

        return (
            <select className="form-control" value={this.props.value} onChange={this.handleChange}>
                {this.props.hasAllOption === true &&
                    <option value={"-1"}>-- ALL --</option>
                }
                {options}
            </select>
        );
    }
}
export default CouponSelect
